import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { trlMessage } from '@/services/i18n';
import PageLayout from '@/components/page/page-layout.vue';
import { UiTitle } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'not-found',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(PageLayout, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: _normalizeClass(_ctx.$style.notFound)
                    }, [
                        _createVNode(_unref(UiTitle), {
                            level: 1,
                            weight: "medium"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(trlMessage)('page.not-found')), 1)
                            ]),
                            _: 1
                        })
                    ], 2)
                ]),
                _: 1
            }));
        };
    }
});
